import { Params, Router } from '@angular/router';
import { CheckpointService } from '@app/core/services';
import { User } from '@app/entity';
import { VoucherRulesForUseDefinitions } from '@app/entity/voucher';

export const navigateNotFound = (router: Router) => {
  router.navigate(['/404'], { skipLocationChange: true });
};

export const navigateToAuth = (router: Router, checkpoint: CheckpointService, next?: string) => {
  // router.navigate performs encodeURIComponent on queryParams.
  // router.url (as well as state.url) is a URI, so is encoded.
  // To prevent double encoding, we turn URI to an IRI by applying decodeURI to it.
  router.navigate(['/auth/login']);
};

export const head = (list: any[], defaultValue: any = null) => list && list.length ? list[0] : defaultValue;

export const flatten = (json: any) => Object.entries(json)
  .reduce((result, [key, value]) => {
    result[key] = head(value);
    return result;
  }, {});

export const navigateToFieldsFill = (router: Router, user: User, next?: string) => {
  router.navigate(['/', user.user_type, 'edit'], { queryParams: { next: decodeURI(next || router.url) } });
};

// usage: force redirect to same route for components reloading
export const forceRedirectTo = (router: Router, uri: string, queryParams?: Params) => {
  router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    router.navigate([uri], { queryParams: queryParams }));
};

export const VOUCHER_RULES_FOR_USE_DEFINITIONS = (): VoucherRulesForUseDefinitions => ({
  hard_copy: 'Ветерану необходимо предъявить номер промокода купона',
  promo_code: 'Ветерану необходимо предъявить купон в распечатанном виде',
  veteran_id: 'Ветерану необходимо предъявить только свое ветеранское удостоверение',
});



// WEBPACK FOOTER //
// ./src/app/shared/utils.ts